import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useToggleLoveStoryMutation } from 'graphql/generated/graphql';

import { useAlgolia } from 'hooks/useAlgolia';
import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

import { getStoryIdToBeAdded } from 'store/modules/playlist';

import ListItem, { useCloseOverlayPageAndShowBanner } from '../ListItem';

const LovedStoriesListItem = () => {
  const { formatMessage } = useIntl();

  const { sendObjectViewedInsight } = useAlgolia();

  const storyToBeAdded = useSelector(getStoryIdToBeAdded);

  const closeOverlayPageAndShowBanner = useCloseOverlayPageAndShowBanner();

  const [toggleLoveStory] = useToggleLoveStoryMutation({
    ...useGraphaelDefaults(),
    variables: {
      storyId: storyToBeAdded?.id || '',
    },
    optimisticResponse: {
      toggleLoveStory: {
        __typename: 'Story',
        id: storyToBeAdded?.id || '',
        loved: !storyToBeAdded?.loved,
      },
    },
  });

  const handleToggleLoveStory = useCallback(() => {
    if (!storyToBeAdded) return;
    toggleLoveStory();

    if (!storyToBeAdded?.loved) {
      sendObjectViewedInsight({
        eventName: 'story_loved',
        index: 'Stories',
        objectId: storyToBeAdded.id,
      });
    }

    closeOverlayPageAndShowBanner(
      storyToBeAdded?.loved
        ? 'SM0123.PlaylistBanner.successmessage2'
        : 'SM0123.PlaylistBanner.successmessage',
    );
  }, [
    closeOverlayPageAndShowBanner,
    sendObjectViewedInsight,
    storyToBeAdded,
    toggleLoveStory,
  ]);

  return (
    <ListItem
      onClick={handleToggleLoveStory}
      selected={storyToBeAdded?.loved}
      text={formatMessage({ id: 'SM0123.Playlist_Modal.Your_favourites' })}
    />
  );
};

export default LovedStoriesListItem;
